import { useContext } from 'react'

import { SearchContext } from '@/components/lemmala-design-system/table/contexts/search-context'

export const useSearchContext = () => {
  return useContext(SearchContext)
}
